export default function createJsApi(iframeApi) {
  return {
    onCreated(cb) {
      iframeApi.onCreated(() => cb(this));
      return this;
    },

    onOrderCreated(cb) {
      iframeApi.onOrderCreated(() => cb(this));
      return this;
    },

    onInit(cb) {
      iframeApi.onInited(() => cb(this));
      return this;
    },

    onOrderFromBalanceCreated(cb) {
      iframeApi.onOrderFromBalanceCreated(cb);
      return this;
    },

    onOrderFromLinkedCardCreated(cb) {
      iframeApi.onOrderFromLinkedCardCreated(cb);
      return this;
    },

    getTheme() {
      return iframeApi.getTheme();
    },

    setTheme(theme) {
      iframeApi.setTheme(theme);
      return this;
    },

    getLanguage() {
      return iframeApi.getLanguage();
    },

    setLanguage(language) {
      iframeApi.setLanguage(language);
      return this;
    },

    destroy() {
      iframeApi.destroy();
    },

    createCartItem(config) {
      iframeApi.createCartItem(config);
      return this;
    },
  };
}
